import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { filesize } from './validator';

@Directive({
    selector: '[filesize][formControlName],[filesize][formControl],[filesize][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FilesizeValidatorDirective),
            multi: true,
        },
    ],
})
export class FilesizeValidatorDirective implements Validator, OnChanges, OnInit {
    private validator: ValidatorFn;

    @Input()
    maxSize: number = 6 * 1024 * 1024;

    ngOnInit() {
        this.validator = filesize(this.maxSize);
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('maxSize' in changes) {
            this.validator = filesize(this.maxSize);
        }
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
